<template>
  <div>
    <div class="banner">
      <ul
        class="list"
        :style="{
          width: banner.data.length * 100 + '%',
          left: -banner.current * 100 + '%',
        }"
      >
        <li v-for="(item, index) in banner.data" :key="index">
          <img :src="item.imgUrl" alt="" />
        </li>
      </ul>
      <a class="btn-pre" @click="resetScroll2(2)"></a>
      <a class="btn-next" @click="resetScroll2(1)"></a>
    </div>

    <ul class="dots">
      <li
        @click="resetScroll2(1, index)"
        :class="{ on: index === banner.current }"
        v-for="(item, index) in banner.data"
        :key="index"
      ></li>
    </ul>
    <div class="banner2">

      <div class="banner2-img">
      <img src="../assets/alevel.png" alt="">
      <img src="../assets/IB.png" alt="">
      <img src="../assets/PRESONAL STATMENT.png" alt="">
      <p class="slogan">
        {{ $t('title1-1') }}<span class="blue">{{ $t('title1-2') }}</span
        >{{ $t('title1-3') }}<span class="blue">{{ $t('title1-4') }}</span
        ><span class="phone-break">{{ $t('title1-5') }}</span>
      </p>
      </div>
      <ul class="cardList">
        <li>
          <div class="card">
            <p class="title">{{ $t('title2') }}</p>
            <p>{{ $t('desc2') }}</p>
          </div>
        </li>
        <li>
          <div class="card">
            <p class="title">{{ $t('title3') }}</p>
            <p>{{ $t('desc3') }}</p>
          </div>
        </li>
        <li>
          <div class="card">
            <p class="title">{{ $t('title4') }}</p>
            <p>{{ $t('desc4') }}</p>
            <p>{{ $t('desc5') }}</p>
          </div>
        </li>
      </ul>
    </div>
      <div class="lesson-introduce">
        <img v-if="$i18n.locale === 'en'" src="../assets/Lesson-en.png" alt="">
        <img v-if="$i18n.locale === 'cn'" src="../assets/Lesson-cn.png" alt="">
        <img v-if="$i18n.locale === 'TW'" src="../assets/Lesson-tw.png" alt="">
        <a @click="$router.push({ path: '/register',query: { type: 0 } })">{{$t('regBtn')}}</a>
      </div>
    <div class="tutorList">
      <p class="title">{{ $t('ourTutor') }}</p>
      <a class="btn-pre" v-if="teacherPage !== 0" @click="teacherPage = 0"></a>
      <a class="btn-next" v-if="teacherPage !== 1" @click="teacherPage = 1"></a>
      <div class="tutorBox">
        <ul class="listItem" :style="{ left: teacherPage * -1200 + 'px' }">
          <li>
            <div class="avatar2">
              <img
                src="../assets/avatar2.jpg"
                alt=""
                style="object-fit: cover"
              />
            </div>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
            <div class="info">
              <p>
                {{ $t('teacher1') }}
                <router-link
                  :to="{ path: '/teachers/teacherDetail', query: { id: 62 } }"
                  class="btn-more"
                  >{{ $t('common.more') }} >></router-link
                >
              </p>
            </div>
            <div class="desc">
              <p class="name">NICK WELSH</p>
              <p class="job">{{ $t('job1') }}</p>
              <p class="job">{{ $t('job1_end') }}</p>
            </div>
          </li>
          <li>
            <div class="avatar2">
              <img
                src="../assets/avatar3.jpg"
                alt=""
                style="object-fit: cover"
              />
            </div>
            <div class="info">
              <p>
                {{ $t('teacher3') }}
                <router-link
                  :to="{ path: '/teachers/teacherDetail', query: { id: 66 } }"
                  class="btn-more"
                  >{{ $t('common.more') }} >></router-link
                >
              </p>
            </div>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
            <div class="desc">
              <p class="name">{{ $t('doctorJISOOJEAN') }}</p>
              <p class="job">{{ $t('job2') }}</p>
              <p class="job">{{ $t('job3') }}</p>
            </div>
          </li>
          <li>
            <div class="avatar2">
              <img
                src="../assets/avatar4.jpg"
                alt=""
                style="object-fit: cover"
              />
            </div>
            <div class="info">
              <p>
                {{ $t('teacher4') }}
                <router-link
                  :to="{ path: '/teachers/teacherDetail', query: { id: 58 } }"
                  class="btn-more"
                  >{{ $t('common.more') }} >></router-link
                >
              </p>
            </div>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
            <div class="desc">
              <p class="name">{{ $t('doctorGeo') }}</p>
              <p class="job">{{ $t('job4') }}</p>
              <p class="job">{{ $t('job5') }}</p>
              <p class="job">{{ $t('job5_end') }}</p>
            </div>
          </li>
          <li>
            <div class="avatar2">
              <img src="../assets/avatar5.jpg" alt="" />
            </div>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
            <a href="https://api.whatsapp.com/send?phone=+85292607280" class="home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
            <div class="info">
              <p>
                {{ $t('teacher5') }}
                <router-link
                  :to="{ path: '/teachers/teacherDetail', query: { id: 65 } }"
                  class="btn-more"
                  >{{ $t('common.more') }} >></router-link
                >
              </p>
            </div>
            <div class="desc" style="width: 280px">
              <p class="name">SARAH LAMBIE</p>
              <p class="job">{{ $t('job6') }}</p>
              <p class="job">{{ $t('job7') }}</p>
              <p class="job">{{ $t('job7_end') }}</p>
            </div>
          </li>
          <!-- 新老师 -->
        </ul>
      </div>

      <div class="app-tutorBox">
        
        <div class="app-title">
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
          <div class="app-desc">
            <p class="app-name">NICK WELSH</p>
            <p class="app-job">{{ $t('job1') }}</p>
            <p class="job">{{ $t('job1_end') }}</p>
          </div>
          <p class="app-content">
            <img src="../assets/avatar2.jpg" alt="" style="object-fit: cover" />
            {{ $t('teacher1') }}
            <div>
            <router-link
              :to="{ path: '/teachers/teacherDetail', query: { id: 62 } }"
              class="btn-more"
              >{{ $t('common.more') }} >></router-link
            >
            </div>
          </p>
        </div>
        <!-- 新增加老师 -->
        <div class="app-title">
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
          <div class="app-desc">
            <p class="app-name">{{ $t('doctorPAUL') }}</p>
            <p class="job">{{ $t('job8') }}</p>
            <p class="app-job">{{ $t('job8_1') }}</p>
            <p class="app-job">{{ $t('job8_2') }}</p>
          </div>
          <p class="app-content">
            <img src="../assets/avatar6.png" alt="" style="object-fit: cover" />
            <span
              :class="`video-${$i18n.locale}`"
              class="app-video"
              @click="
                $router.push({
                  path: '/teachers/teacherDetail',
                  query: { id: 95, tab: 2 },
                })
              "
            >
            </span>
            {{ $t('teacher2') }}
            <div>
            <router-link
              :to="{ path: '/teachers/teacherDetail', query: { id: 95 } }"
              class="btn-more"
              >{{ $t('common.more') }} >></router-link
            >
            </div>
          </p>
        </div>
        <div class="app-title">
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
          <div class="app-desc">
            <p class="app-name">{{ $t('doctorJISOOJEAN') }}</p>
            <p class="app-job">{{ $t('job2') }}</p>
            <p class="app-job">{{ $t('job3') }}</p>
          </div>
          <p class="app-content">
            <img src="../assets/avatar3.jpg" alt="" style="object-fit: cover" />
            {{ $t('teacher3') }}
            <div>
            <router-link
              :to="{ path: '/teachers/teacherDetail', query: { id: 66 } }"
              class="btn-more"
              >{{ $t('common.more') }} >></router-link
            >
            </div>
          </p>
        </div>
        <div class="app-title">
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
          <div class="app-desc">
            <p class="app-name">{{ $t('doctorGeo') }}</p>
            <p class="app-job">{{ $t('job4') }}</p>
            <p class="app-job">{{ $t('job5') }}</p>
            <p class="job">{{ $t('job5_end') }}</p>
          </div>
          <p class="app-content">
            <span
              :class="`video-${$i18n.locale}`"
              class="app-video"
              @click="
                $router.push({
                  path: '/teachers/teacherDetail',
                  query: { id: 58, tab: 2, videoId: 'video' },
                })
              "
            >
            </span>
            <img src="../assets/avatar4.jpg" alt="" style="object-fit: cover" />
            {{ $t('teacher4') }}
            <div>
            <router-link
              :to="{ path: '/teachers/teacherDetail', query: { id: 58 } }"
              class="btn-more"
              >{{ $t('common.more') }} >></router-link
            >
            </div>
          </p>
        </div>
        <div class="app-title">
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'en'" src="../assets/en-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'cn'" src="../assets/cn-home-button.png" alt=""></a>
          <a href="https://api.whatsapp.com/send?phone=+85292607280" class="app-home-whatsapp"><img v-if="$i18n.locale === 'TW'" src="../assets/tw-home-button.png" alt=""></a>
          <div class="app-desc">
            <p class="app-name">SARAH LAMBIE</p>
            <p class="app-job">{{ $t('job6') }}</p>
            <p class="app-job">{{ $t('job7') }}</p>
            <p class="app-job">{{ $t('job7_end') }}</p>
          </div>
          <p class="app-content">
            <span
              :class="`video-${$i18n.locale}`"
              class="app-video"
              @click="
                $router.push({
                  path: '/teachers/teacherDetail',
                  query: { id: 65, tab: 2, videoId: 'video' },
                })
              "
            >
            </span>
            <img src="../assets/avatar5.jpg" alt="" style="object-fit: cover" />
            {{ $t('teacher5') }}
            <div>
              <router-link
              :to="{ path: '/teachers/teacherDetail', query: { id: 65 } }"
              class="btn-more"
              >{{ $t('common.more') }} >></router-link
            >
            </div>
          </p>
        </div>
      </div>

      <ul class="dots">
        <li @click="teacherPage = 0" :class="{ on: teacherPage === 0 }"></li>
        <li @click="teacherPage = 1" :class="{ on: teacherPage === 1 }"></li>
      </ul>
    </div>
    <div class="tutorItem">
      <p class="title">{{ $t('title5') }}</p>
      <div class="items">
        <div class="avatar">
          <div class="photo">
            <img src="../assets/avatar.jpg" alt="" style="object-fit: cover" />
          </div>
          <p class="name">{{ $t('p8') }}</p>
          <p class="ident">{{ $t('p9') }}</p>
        </div>
        <div class="desc">
          <p>{{ $t('p1') }}</p>
          <p>{{ $t('p2') }}</p>
          <p>{{ $t('p3') }}</p>
          <p>{{ $t('p4') }}</p>
          <p>{{ $t('p5') }}</p>
          <p>{{ $t('p6') }}</p>
          <p class="dear">{{ $t('p7') }}</p>
          <p>{{ $t('p8') }}</p>
        </div>
      </div>
    </div>
    <p class="step-title">{{ $t('stepTitle') }}</p>
    <div class="app-step-list">
      <div class="content">
        <p class="title">{{ $t('stepTitle1') }}</p>
        <img src="../assets/icon1.png" alt="" style="object-fit: cover" />
        <p>{{ $t('step1') }}</p>
        <div class="clear"></div>
      </div>
      <div class="content">
        <p class="title">{{ $t('stepTitle2') }}</p>
        <img src="../assets/icon2.png" alt="" style="object-fit: cover" />
        <p>{{ $t('step2') }}</p>
        <div class="clear"></div>
      </div>
      <div class="content">
        <p class="title">{{ $t('stepTitle3') }}</p>
        <img src="../assets/icon3.png" alt="" style="object-fit: cover" />
        <p>{{ $t('step3') }}</p>
        <div class="clear"></div>
      </div>
      <div class="content">
        <p class="title">{{ $t('stepTitle4') }}</p>
        <img src="../assets/icon4.png" alt="" style="object-fit: cover" />
        <p>{{ $t('step4') }}</p>
        <div class="clear"></div>
      </div>
      <div class="content">
        <p class="title">{{ $t('stepTitle5') }}</p>
        <img src="../assets/icon5.png" alt="" style="object-fit: cover" />
        <p>{{ $t('step5') }}</p>
        <div class="clear"></div>
      </div>
    </div>
    <ul class="step-list">
      <li>
        <div class="icon icon1"></div>
        <div class="info">
          <p class="title">{{ $t('stepTitle1') }}</p>
          <p>{{ $t('step1') }}</p>
        </div>
      </li>
      <li>
        <div class="icon icon2"></div>
        <div class="info">
          <p class="title">{{ $t('stepTitle2') }}</p>
          <p>{{ $t('step2') }}</p>
        </div>
      </li>
      <li>
        <div class="icon icon3"></div>
        <div class="info">
          <p class="title">{{ $t('stepTitle3') }}</p>
          <p>{{ $t('step3') }}</p>
        </div>
      </li>
      <li>
        <div class="icon icon4"></div>
        <div class="info">
          <p class="title">{{ $t('stepTitle4') }}</p>
          <p>{{ $t('step4') }}</p>
        </div>
      </li>
      <li>
        <div class="icon icon5"></div>
        <div class="info">
          <p class="title">{{ $t('stepTitle5') }}</p>
          <p>{{ $t('step5') }}</p>
        </div>
      </li>
    </ul>
    <Platform></Platform>
    <!-- v-if="advShow" -->
    <div class="adv" v-if="advShow">
      <img
        class="adv-close"
        src="../assets/close.png"
        alt=""
        @click="
          advShow = false
          advHide = true
        "
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'en'"
        src="../assets/adv.png"
        alt=""
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'cn'"
        src="../assets/adv_cn.png"
        alt=""
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'TW'"
        src="../assets/adv_tw.png"
        alt=""
      />
      <a
        class="ui-btn"
        href="https://api.whatsapp.com/send?phone=+85292607280"
        >{{ $t('common.advBtn') }}</a
      >
    </div>
    <el-dialog :visible.sync="regSuccess" width="100%" >
      <img
        class="adv-img"
        v-if="$i18n.locale === 'en'"
        src="../assets/registration success_ENg.png"
        width="100%"
        fit="cover"
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'cn'"
        src="../assets/registration success_SCN.png"
        width="100%"
        fit="cover"
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'TW'"
        src="../assets/registration success_TCN.png"
        width="100%"
        fit="cover"
      />
    </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Platform from '@/components/Platform.vue'
import { getBySpace, getArticleList } from '@/service/api.js'
import { getTeacherList } from '@/service/teacherApi.js'
export default {
  components: { Platform },
  data() {
    return {
      banner: {
        data: [],
        inter: '',
        current: 0,
        time: 5000,
      },
      msgs: {
        //动态资讯
        data: [],
        inter: '',
        animate: false,
        time: 5000,
      },
      teacherPage: 0,
      teachers: {
        data: [],
        current: 0,
      },
      advShow: false,
      advHide: false,
      regSuccess: false,
    }
  },
  mounted() {
    if (this.$route.query.regMsgShow) {
      this.regSuccess = true;
    }
    window.addEventListener('scroll', this.scrollHandle);
    this.getArticleList()
    this.msgs.inter = setInterval(this.scroll, this.msgs.time) //5秒自动滚动一次动态资讯
    this.banner.inter = setInterval(this.scroll2, this.banner.time) //3秒自动滚动一次轮播页
    this.getTeacherList()
    this.getBySpace()
  },
  methods: {
    scrollHandle(e) {
      let top = e.srcElement.scrollingElement.scrollTop;    // 获取页面滚动高度
      let clientWidth = document.body.clientWidth;
      if ((top > 3800 && clientWidth <= 768) || (top > 2200 && clientWidth > 768)) {
        if (this.advHide) {
          return false;
        }
        this.advShow = true;
      }

    },
    scroll(type) {
      // 滚动一次动态资讯，动画完成后把数组最后一个数据插入到第一个，位置还原, type === 1向下滚动,type===2向上滚动
      if (type === 2) {
        this.msgs.animate = type
      } else {
        this.msgs.animate = 1
      }
      setTimeout(() => {
        if (type === 2) {
          this.msgs.data.unshift(this.msgs.data[this.msgs.data.length - 1])
          this.msgs.data.pop()
        } else {
          this.msgs.data.push(this.msgs.data[0])
          this.msgs.data.shift()
        }
        this.msgs.animate = 0
      }, 300)
    },
    resetScroll(type) {
      clearInterval(this.msgs.inter)
      this.scroll(type)
      this.msgs.inter = setInterval(this.scroll, this.msgs.time)
    },
    scroll2(type, index) {
      if (index !== undefined) {
        this.banner.current = index
      } else if (type === 2) {
        if (this.banner.current === 0) {
          this.banner.current = this.banner.data.length
        }
        this.banner.current--
      } else {
        this.banner.current++
        if (this.banner.current === this.banner.data.length) {
          this.banner.current = 0
        }
      }
    },
    resetScroll2(type, index) {
      clearInterval(this.banner.inter)
      this.scroll2(type, index)
      this.banner.inter = setInterval(this.scroll2, this.banner.time)
    },
    async getTeacherList() {
      let res = await getTeacherList({
        pageNO: 1,
        pageSize: 7,
        totalCount: 0,
        isRecommend: 1,
        isTop: 1
      })
      if (res.data.status === 1) {
        this.teachers.data = res.data.data
      }
      // console.log(res)
    },
    async getBySpace() {
      // 获取广告内容
      let res
      if (localStorage.getItem('lang') === 'en') {
        res = await getBySpace({ code: 'f49667c8aa6b4433899bd27a92e6cbe8' })
      } else {
        res = await getBySpace({ code: 'f49667c8aa6b4433899bd27a92e6cbe8' })
      }
      if (res.data.status === 1) {
        let imgArr = res.data.data.contents
        if (imgArr.length) {
          this.banner.data = []
          for (let i = 0; i < imgArr.length; i++) {
            this.banner.data.push({ imgUrl: imgArr[i].imgUrl })
          }
        }
      }
    },
    async getArticleList() {
      // 获取资讯列表
      let res = await getArticleList()
      if (res.data.status === 1) {
        this.msgs.data = res.data.data
      }
    },
  },
  destroyed() {
    clearInterval(this.msgs.inter)
  },
}
</script>
<style lang="scss" scoped>
.adv {
  width: 600px;
  height: 600px;
  padding: 15px;
  position: fixed;
  z-index: 999999;
  top: 50%;
  left: 50%;
  margin-top: -300px;
  margin-left: -300px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  img {
    background-size: cover;
  }
  .adv-img {
    width: 100%;
    height: auto;
  }
  .adv-close {
    position: absolute;
    z-index: 22;
    color: #000;
    width: 10px;
    right: 4px;
    top: 4px;
  }
  a {
    font-size: 12px;
    z-index: 2;
    left: 50%;
    margin-left: -75px;
    bottom: 40px;
    position: absolute;
    background: #930000;
    color: #fff;
    box-shadow: 0 5px 20px #e0e0e0;
  }
}
.banner {
  position: relative;
  overflow: hidden;
  &:hover {
    .btn-pre,
    .btn-next {
      opacity: 0.5;
    }
  }
  .list {
    display: flex;
    transition: left 0.3s;
    left: 0;
    position: relative;
    li {
      position: relative;
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .info {
      position: absolute;
      top: 245px;
      width: 678px;
      left: 50%;
      margin-left: -600px;
      text-align: center;
      font-size: 32px;
      line-height: 42px;
    }
    img {
      width: 100%;
    }
  }
  .title1 {
    font-size: 42px;
    line-height: 55px;
  }
  .btn-pre,
  .btn-next {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 50%;
    margin-top: -30px;
    background: rgba(#000, 0.1) url(../assets/arrow_left2.png) no-repeat center
      center;
    border-radius: 50%;
    opacity: 0;
    transition: all 0.3s;
    &:hover {
      opacity: 1;
    }
    &:active {
      background-color: rgba(#000, 0.05);
    }
  }
  .btn-pre {
    left: 50%;
    margin-left: -600px;
  }
  .btn-next {
    right: 50%;
    margin-right: -600px;
    transform: rotate(180deg);
  }
}
.dots {
  display: flex;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  height: 26px;
  border-radius: 26px;
  padding: 5px;
  margin-top: 50px;
  justify-content: center;
  li {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: rgb(153, 153, 153);
    margin: 0 15px;
    cursor: pointer;
  }
  .on {
    background: #000;
  }
}
.banner2 {
  margin-top: 50px;
  height: 800px;
  background: url(../assets/banner3.jpg) no-repeat center top;
  position: relative;
  .banner2-img {
    img {
      width: 60px;
      position: absolute;
      left: 40px;
      margin-left: 30px;
      top: 37px;
      display: block;
    }
    img:nth-child(2) {
      top: 140px;
    }
    img:nth-child(3) {
      top: 240px;
    }
  }

  // img:nth-child(2) {
  //   top: 45px;
  // }
  // img:nth-child(3) {
  //   top: 80px;
  // }
  .slogan {
    position: absolute;
    left: 50%;
    top: 20px;
    width: 57.3vw;
    margin-left: -28.65vw;
    font-size: 3.6vw;
    font-weight: bold;
    color: #fff;
    line-height: 1.5;
    text-align: center;
    text-shadow: 6px 3px 6px #1e183d;
  }
  .blue {
    color: #57c7d7;
  }
}
.cardList {
  padding: 340px 0;
  width: 1440px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  li {
    position: relative;
    height: 385px;
    padding: 40px 30px 0 0;
    width: 376px;
    text-align: center;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 30px;
      right: 0;
      height: 348px;
      background: #152040;
    }
  }
  .card {
    background: #57c7d7;
    height: 100%;
    position: relative;
    color: #fff;
    font-size: 20px;
    line-height: 32px;
    overflow: hidden;
    padding: 15px;
    word-break: normal;
  }
  .title {
    font-size: 24px;
    text-align: center;
    padding: 5px;
  }
  p {
    margin-top: 5px;
    // text-align: justify;
  }
}
.tutorItem {
  padding: 50px 0;
  background: #fff;
  position: relative;
  overflow: hidden;
  height: 830px;
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    left: 50%;
    top: 290px;
    margin-left: -540px;
    height: 530px;
    background: #57c7d7;
  }
  .title {
    text-align: center;
    width: 520px;
    margin: 0 auto;
    font-weight: bold;
    font-size: 20px;
    color: #001d48;
    border-bottom: 15px solid #99b4a1;
    position: relative;
    line-height: 48px;
  }
  .items {
    width: 1440px;
    margin: 45px auto 0;
    position: relative;
  }
  .avatar {
    position: absolute;
    top: 20px;
    right: 0;
    width: 510px;
    padding: 0 50px;
    p {
      font-size: 24px;
      font-weight: bold;
      color: #fff;
      padding: 0 32px;
      text-shadow: 8px 5px 12px #1e183d;
    }
    .name {
      margin: 30px 0;
      text-transform: uppercase;
    }
    .ident {
      font-style: italic;
    }
  }
  .photo {
    border: 4px solid rgba(0, 29, 72, 0.65);
    font-size: 0;
    width: 340px;
    height: 340px;
    box-shadow: 7px 0 60px 0 rgba(30, 24, 61, 0.33);
    img {
      width: 100%;
      height: 100%;
    }
  }
  .desc {
    position: absolute;
    top: 0;
    left: 30px;
    right: 510px;
    height: 640px;
    border: 15px solid #001d48;
    border-radius: 15px;
    background: #fff;
    padding: 10px 20px;
    line-height: 28px;
    font-size: 15px;
    color: #2b302e;
    font-weight: bold;
    p {
      margin-bottom: 22px;
    }
    .dear {
      margin-bottom: 0;
    }
  }
}
.tutorList {
  background: #fff;
  padding-top: 50px;
  position: relative;
  .title {
    text-align: center;
    width: 520px;
    margin: 0 auto;
    font-weight: bold;
    font-size: 20px;
    color: #001d48;
    border-bottom: 15px solid #99b4a1;
    position: relative;
    line-height: 48px;
  }
  .tutorBox {
    margin: 60px auto;
    width: 1200px;
    overflow: hidden;
  }
  .btn-pre,
  .btn-next {
    position: absolute;
    width: 60px;
    height: 60px;
    top: 315px;
    left: 50%;
    background: rgba(#000, 0.1) url(../assets/arrow_left2.png) no-repeat center
      center;
    border-radius: 50%;
    transition: all 0.3s;
  }
  .btn-pre {
    margin-left: -670px;
  }
  .btn-next {
    margin-left: 610px;
    transform: rotate(180deg);
  }
  .listItem {
    width: 2400px;
    position: relative;
    overflow: hidden;
    left: 0;
    transition: left 0.3s;
    li {
      width: 580px;
      margin: 0 10px;
      position: relative;
      height: 460px;
      float: left;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        left: 80px;
        bottom: 130px;
        background: #061c45;
      }
    }
    .avatar2 {
      position: absolute;
      left: 0;
      top: 60px;
      width: 267px;
      height: 267px;
      box-shadow: 3px -3px 18px #251b58;
      z-index: 1;
      background: #fff;
      font-size: 0;
    }
    .info {
      word-break: normal;
      overflow-y: auto;
      width: 330px;
      height: 320px;
      overflow-y: auto;
      position: absolute;
      bottom: 0px;
      right: 25px;
      background: #57c7d7;
      z-index: 2;
      font-size: 16px;
      line-height: 24px;
      padding: 15px;
      color: #061c45;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .desc {
    position: absolute;
    right: 25px;
    top: 30px;
    font-weight: bold;
    text-align: right;
    font-size: 15px;
    width: 235px;
  }
  .name {
    color: white;
    margin-bottom: 18px;
  }
  .job {
    color: #57c7d7;
  }
  .btn-more {
    // position: absolute;
    // bottom: 15px;
    // right: 20px;
    color: #fff;
  }
}
.step-title {
  text-align: center;
  width: 520px;
  margin: 30px auto 10px;
  font-weight: bold;
  font-size: 20px;
  color: #001d48;
  border-bottom: 15px solid #99b4a1;
  position: relative;
  line-height: 48px;
}
.step-list {
  padding: 30px 0;
  width: 1200px;
  margin: 0 auto;
  li {
    overflow: hidden;
    padding: 30px;
  }
  .icon {
    width: 500px;
    height: 300px;
    background-repeat: no-repeat;
    background-position: center center;
    float: left;
  }
  .icon1 {
    background-image: url(../assets/icon1.png);
  }
  .icon2 {
    background-image: url(../assets/icon2.png);
    // background-position-x: 110px;
    // background-size: 221px auto;
  }
  .icon3 {
    background-image: url(../assets/icon3.png);
    // background-position-x: 110px;
    // background-size: 227px auto;
  }
  .icon4 {
    background-image: url(../assets/icon4.png);
    background-position-x: 85px;
    transform: scale(1.2);
  }
  .icon5 {
    background-image: url(../assets/icon5.png);
    background-position-x: 45px;
  }
  .desc {
    overflow: hidden;
  }
  p {
    font-size: 16px;
    color: #666;
    line-height: 32px;
  }
  .title {
    font-size: 18px;
    word-break: break-all;
    font-weight: bold;
    margin-bottom: 15px;
  }
}
.app-tutorBox,
.app-step-list,
.app-banner {
  display: none;
}
.home-whatsapp {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 140px;
}
.lesson-introduce {
  width: 800px;
  margin: 0 auto;
  position: relative;
  a {
    background: #d2474f;
    border-radius: 5px;
    font-size: 25px;
    line-height: normal;
    padding: 15px 20px;
    color: #fff;
    position: absolute;
    display: block;
    top: 28px;
    right: 40px;
  }
  img {
    width: 100%;
  }
}
@media screen and (max-width: 768px) {
  .blue {
    display: block;
  }
  .banner2 {
    .banner2-img {
      img {
        width: 25px;
        position: absolute;
        left: -20px;
        // margin-left: 30px;
        top: 20px;
        display: block;
      }
      img:nth-child(2) {
        top: 66px;
      }
      img:nth-child(3) {
        top: 114px;
      }
    }
  }

  .adv {
    width: 360px;
    height: 360px;
    margin-top: -180px;
    margin-left: -180px;
    a {
      margin-left: -70px;
      top: 290px;
    }
  }
  .lesson-introduce {
    width: 100%;
    margin: 20px 0;
    img {
      height: auto;
    }
    a {
      font-size: 16px;
      padding: 5px;
      top: 11px;
      right: 10px;
    }
  }
  .btn-more {
    color: #ffff99 !important;
    text-align: right;
  }
  .app-step-list {
    margin-top: 24px;
  }
  .app-step-list div {
    text-align: center;
  }
  .tutorItem .desc p {
    margin-bottom: 5px;
  }
  .tutorBox {
    display: none;
  }
  .dots,
  .banner2 {
    margin-top: 10px;
  }
  .dots li {
    width: 8px;
    height: 8px;
  }
  .banner2 {
    height: auto;
  }
  .banner2 .slogan {
    font-size: 16px;
    padding: 24px 30px;
    height: 162px;
    position: inherit;
  }
  .cardList {
    padding: 0 20px;
    width: 100%;
    flex-wrap: wrap;
  }
  .cardList li {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 10px;
    height: auto;
    padding: 40px 20px 0 0;
    // height: 318px;
  }
  .cardList li::before {
    top: 20px;
    bottom: 20px;
    left: 20px;
    height: auto;
    // display: none;
  }
  .step-title {
    padding: 12px 0;
    padding-bottom: 5px;
    width: 100%;
    display: block;
  }
  .tutorList {
    .dots {
      display: none;
    }
  }
  .app-step-list {
    display: block;
    padding: 0 10px;
    div {
      .title {
        font-weight: bold;
        text-align: center;
        // padding: 10px 0;
        // margin-bottom: 12px;
        font-size: 17px;
      }
      border-radius: 5px;
      padding: 12px;
      margin-bottom: 12px;
      border: 1px solid #ccc;
      font-size: 16px;
      img {
        width: 220px;
        height: auto;
        // margin-bottom: 12px;
        // float: left;
        // padding: 10px;
        margin: 24px 0;
      }
      .clear {
        clear: both;
        display: none;
      }
    }
  }
  .platform-list {
    margin: 0;
  }
  .tutorItem .photo {
    width: 220px;
    height: 220px;
  }
  .tutorList .btn-more {
    position: initial;
  }
  .app-tutorBox {
    display: block;
    padding: 10px;
    .app-title {
      padding: 10px;
      background: #061c45;
      border: 5px solid #ccc;
      word-break: break-all;
      margin-bottom: 10px;
      border-radius: 5px;
      position: relative;
      .app-home-whatsapp {
        position: absolute;
        right: 18px;
        top: 18px;
        img {
          width: 120px;
          border-radius: 8px;
        }
      }
    }
    .app-content {
      color: #fff;
      font-size: 16px;
      word-break: normal;
      position: relative;

      img {
        width: 220px;
        height: auto;
        display: block;
        margin: 10px;
        padding-top: 0;
        // float: left;
      }
      // .btn-more {
      //   color: #ffff99;
      //   text-align: right;
      // }
    }
    .app-video {
      position: absolute;
      right: 0;
      display: block;
      width: 108px;
      height: 40px;
      background: url(../assets/video.png) no-repeat;
      background-size: 100%;
      // padding: 4px;
      border-radius: 5px;
      top: 100px;
      right: 0px;
    }
    .video-cn {
      background: url(../assets/video-cn.png) no-repeat;
      background-size: 100%;
    }
    .video-TW {
      background: url(../assets/video-tw.png) no-repeat;
      background-size: 100%;
    }
    .app-desc {
      padding: 10px;
      font-weight: bold;
      text-align: left;
      // font-size:12px;
    }
    .app-name {
      color: white;
      font-size: 16px;
      padding-bottom: 10px;
    }
    .app-job {
      color: #57c7d7;
      word-break: normal;
      // word-break: keep-all;
    }
  }
  .cardList {
    .title,
    p {
      font-size: 16px;
    }
  }
  .cardList .title {
    padding: 0;
    margin: 0;
  }
  .cardList .card {
    padding: 15px;
    line-height: normal;
    // font-size: 1.5vw;
  }
  .tutorList {
    padding: 0px;
  }
  .tutorList .title {
    width: 100%;
  }
  .tutorList .tutorBox {
    margin: 20px auto;
    width: 100%;
  }
  .tutorList .listItem {
    width: 100%;
  }
  .tutorList .listItem .avatar2 {
    // width: 50%;
    top: 120px;
  }
  .tutorList .desc {
    // font-size: 2vw;
    position: absolute;
    top: 0;
    right: 20px;
    width: 50%;
    margin: 10px 0;
  }
  .tutorItem .title,
  .tutorItem .avatar,
  .tutorItem .items,
  .article {
    width: 100%;
  }
  .tutorItem .title {
    line-height: normal;
    padding-bottom: 15px;
  }
  .step-list {
    display: none;
  }
  .tutorItem {
    padding: 0 10px;
    height: auto;
  }
  .tutorItem::before {
    width: 100%;
    margin-left: 0;
    left: 0;
  }
  .tutorItem .avatar .name {
    margin: 8px 0;
  }
  .tutorItem .avatar {
    position: relative;
    top: 0;
  }
  .tutorItem .avatar p {
    line-height: auto;
    margin: 8px 0;
    font-size: 20px;
  }
  .tutorItem .desc {
    height: auto;
    position: relative;
    width: 100%;
    right: 0;
    left: inherit;
    line-height: normal;
    word-break: normal;
  }
  .banner2 {
    background: none;
    .slogan {
      position: initial;
      margin: 0;
      background: url(../assets/banner3.jpg) no-repeat center top;
      background-size: cover;
      // padding: 30px;
      width: 100%;
    }
  }
  .step-title {
    margin: 0;
  }
  .platform {
    padding: 0;
  }
}
</style>
<i18n>
{
  "cn": {
    "regBtn":"立即注册",
    "teacher1":"在伊顿公学教学多年后（其中的八年我曾担任英语系主任），我移居到了牛津並与各年级的学生进行一对一辅导，當中由十一岁起到牛津、剑桥大学入学生均有辅导过，偶尔亦会辅导本科学生，透过辅导鼓励及协助学生超越他们原本的目标。我一直都热爱语言和文学，并致力于将其生命力带给我的学生，让他们能够领悟到语言和文学可给予的兴奋和愉悦感。我们教程的内容及方向将由我来指导，您来给予提议。在我们进行了初步讨论及咨询之后，您可以告诉我您所希望实现的目标，以及任何造成了特别学习困难的问题，我将为日后的课程制定一个集中的学习计划。",
    "teacher2":"我是布里斯托尔大学的神经生理学副教授，之前是伦敦帝国理工学院生物工程系的高级讲师。自2011 年以来，我一直在营运一个独立的研究小组，并将基础研究与大学本科和研究生教育相结合。我在牛津大学获得了我第一个学位（生理科学），随后在伦敦大学学院获得了神经科学博士学位。",
    "teacher3":"您好，我现在是一名顾问，在牛津大学获得跨学科生物科学博士学位。在我修读博士学位之前，我在伦敦帝国理工学院生物学（一级荣誉学位）以全班第一的成绩毕业。我可以提供 GCSE / Alevel / AP / IB 生物学的辅导，以及大学申请指导（简历，个人陈述，面试技巧）。",
    "teacher4":"我拥有牛津大学哲学系的本科、硕士和博士学位，同时还拥有牛津大学的数学 PGCE 学位，以及高等教育学院的学习和教学董事职位。成为我家第一个获得博士学位的人让我感到非常自豪。我的独特教学方式就是将哲学的核心思维应用到了计算科学和数学中。我还会说一口流利的法语和意大利语。",
    "teacher5":"您好，我拥有剑桥大学彭布罗克学院的英语学位。我辅导不同年龄段的学生已经有十多年了。英语文学是我的专长，我最喜欢教导十六岁及以上的学生，与他们分享我对文本分析的热情。每一部文学作品中都拥有很多值得我们发掘的地方，而英语是一个极其丰富的语言。我对我的学科的这些方面充满着无限热情，而我的目标就是让我的学生在和我一起学习的过程中找到乐趣。",
    "doctorJISOOJEAN":"JISOO JEAN 博士",
    "doctorGeo":"GEOFFREY FERRARI 博士",
    "doctorPAUL":"PAUL CHADDERTON 博士",
    "doctor":"博士",
    "news": "动态资讯",
    "title1": "与来自牛津、剑桥大学的世界级导师一对一在线授课",
    "title1-1": "与来自",
    "title1-2": "牛津、剑桥大学",
    "title1-3": "的",
    "title1-4": "世界级导师",
    "title1-5": "一对一在线授课",
    "desc1": "量身定制 乐享学习",
    "title2": "我们覆盖的范围",
    "desc2": "为 A-level 和 IB 课程中的所有科目提供辅导；大学申请，包括入学申请和撰写个人陈述的建议；面试练习和包括考试技巧在内的必要技能。",
    "title3": "我们的导师团队",
    "desc3": "我们所有的导师都拥有牛津或剑桥大学的学术背景，包括：教授，讲师，博士后，研究生和毕业生，您可以从中选择适合您的导师。",
    "title4": "我们如何辅导",
    "desc4": "通过课前评估和面试，了解每位学生正在面对的问题、需要和个人目标。",
    "desc5": "导师将为学生量身定制一个特定的学习方案，以帮助学生实现他/她的目标和理想。",
    "title5": "导师总监致辞",
    "p1": "作为牛剑学术的导师总监，我谨代表牛剑学术欢迎所有学员，无论是现有的，还是即将成为我们一份子的您，欢迎您们来应用我们全新的 APP 及网站。",
    "p2": "牛剑学术为自己订立的挑战，就是确保提供给我们所有学员卓越的学术辅导。这是因为我们深切了解学员的期望与所需，所以我们必须一步到位，共同迈向成功之路。",
    "p3": "我的角色与责任是组建一个顶尖的导师团队。我们的导师都是拥有超高学历的学者（有些甚至是学术界内举足轻重的人物），同时也是优秀且专业的教师。这是非常关键的，因为只精通于自己专科的xue并不等同出色的教育家。出色的教育家必须同时拥有同理心和良好的沟通技能。能将知识传授给他人却是教育的关键。",
    "p4": "我们确实对我们的导师团队感到自豪。我们的导师都拥有牛剑 (牛津、剑桥大学) 的学术背景，而且都经过了严格的甄选：分两个阶段的简历审查程序，深入的面试，以及接受一套清晰而彻底的指引和内部规定。",
    "p5": "我们深信，我们导师团队的才能是独一无二的，而我们有足够的信心，一旦您开始在牛剑学术优秀导师的指导下获得出色的学术成就，我们必定得到您的认同及肯定。",
    "p6": " 牛剑学术祝您在学习的道路上再创佳绩！",
    "p7": " ",
    "p8": "罗伯特·芬奇",
    "p9": "导师总监",
    "step1": "导师先了解学生的学术水平、学术上的需要及目标并作出评估，再为学生定制个人化及目标性的学习方式及练习。每次上課都会跟进并就学习状况与进度而调整，以正确及有效的教学模式，让学生的学术成就得以提升及突破。",
    "step2": "我们所有的导师都是拥有英国牛津大学或剑桥大学（简称“Oxbridge”）学术资历的教授、讲师、博士后、研究生或毕业生。",
    "step3": "我们的导师除了拥有超卓的学术成就，对于教育、辅导新一代都充满热情与执着，在教育理念上有着很重的使命感。",
    "step4": "我们拥有不同的师资，可以让你挑选不同科目专业的导师。除了 IB 及 GCE A-LEVEL，导师还可以指导学生撰写个人陈述，用于申请世界各地一流的大学，让学生在众多大学申请者中脱颖而出。",
    "step5": "使用简单，可轻易于手机 APP 上随时随地预约课堂，学生可以使用桌上电脑、手提电脑、iPad 平板电脑及手机轻松预约及在线上课。",
    "stepTitle": "为什么选择牛剑学术？",
    "stepTitle1": "正确有效的一对一在线辅导",
    "stepTitle2": "世界顶尖导师团队",
    "stepTitle3": "教育使命",
    "stepTitle4": "各科目及个人陈述指导",
    "stepTitle5": "网页及 APP 操作",
    "ourTutor": "我们的星级导师",
    "job1": "伊顿公学前任英语系主任",
    "job1_end":" ",
    "job2": "生物学",
    "job3": "牛津大学博士",
    "job4": "数学及哲学",
    "job5": "牛津大学前任讲师",
    "job5_end":" ",
    "job6": "英语语言文学",
    "job7": "剑桥大学硕士",
    "job7_end":" ",
    "job8":"生物学",
    "job8_1":" ",
    "job8_2":"神经生理学副教授"
  },
  "TW": {
    "regBtn":"立即註冊",
    "teacher1":"在伊頓公學教學多年後（其中的八年我曾擔任英語系主任），我移居到了牛津並與各年級的學生進行一對一輔導，當中由十一歲起到牛津、劍橋大學入學生均有輔導過，偶爾亦會輔導本科學生，透過輔導鼓勵及協助學生超越他們原本的目標。我一直都熱愛語言和文學，並致力於將其生命力帶給我的學生，讓他們能够領悟到語言和文學可給予的興奮和愉悅感。我們教程的內容及方向將由我來指導，您來給予提議。在我們進行了初步討論及諮詢之後，您可以告訴我您所希望實現的目標，以及任何造成了特別學習困難的問題，我將為日後的課程製定一個集中的學習計畫。",
    "teacher2":"我是布裏斯托爾大學的神經生理學副教授，之前是倫敦帝國理工學院生物工程系的高級講師。自2011年以來，我一直在營運一個獨立的研究小組，並將基礎研究與大學本科和研究生教育相結合。我在牛津大學獲得了我第一個學位（生理科學），隨後在倫敦大學學院獲得了神經科學博士學位。",
    "teacher3":"您好，我現在是一名顧問，在牛津大學獲得跨學科生物科學博士學位。在我修讀博士學位之前，我在倫敦帝國理工學院生物學（一級榮譽學位）以全班第一的成績畢業。我可以提供GCSE / Alevel / AP / IB生物學的輔導，以及大學申請指導（簡歷，個人陳述，面試技巧）。",
    "teacher4":"我擁有牛津大學哲學系的本科、碩士和博士學位，同時還擁有牛津大學的數學PGCE學位，以及高等教育學院的學習和教學董事職位。成為我家第一個獲得博士學位的人讓我感到非常自豪。我的獨特教學方式就是將哲學的覈心思維應用到了計算科學和數學中。我還會說一口流利的法語和義大利語。",
    "teacher5":"您好，我擁有劍橋大學彭布羅克學院的英語學位。我輔導不同年齡段的學生已經有十多年了。英語文學是我的專長，我最喜歡教導十六歲及以上的學生，與他們分享我對文字分析的熱情。每一部文學作品中都擁有很多值得我們發掘的地方，而英語是一個極其豐富的語言。我對我的學科的這些方面充滿著無限熱情，而我的目標就是讓我的學生在和我一起學習的過程中找到樂趣。",
    "doctorJISOOJEAN":"JISOO JEAN 博士",
    "doctorGeo":"GEOFFREY FERRARI 博士",
    "doctorPAUL":"PAUL CHADDERTON 博士",
    "doctor":"博士",
    "news": "動態資訊",
    "title1": "與來自牛津、劍橋大學的世界級導師一對一在線輔導",
    "title1-1": "與來自",
    "title1-2": "牛津、劍橋大學",
    "title1-3": "的",
    "title1-4": "世界級導師",
    "title1-5": "一對一在線輔導",
    "desc1": "量身定制 樂享學習",
    "title2": "我們覆蓋的範圍",
    "desc2": "為 A-level 和 IB 課程中的所有科目提供輔導；大學申請，包括入學申請和撰寫個人陳述的建議；面試練習和包括考試技巧在內的必要技能。",
    "title3": "我們的導師團隊",
    "desc3": "我們所有的導師都擁有牛津或劍橋大學的學術背景，包括：教授，講師，博士後，研究生和畢業生，您可以從中選擇適合您的導師。",
    "title4": "我們如何輔導",
    "desc4": "通過課前評估和面試，了解每位學生正在面對的問題、需要和個人目標。",
    "desc5": "導師將為學生量身定制一個特定的學習方案，以幫助學生實現他/她的目標和理想。",
    "title5": "導師總監致辭",
    "p1": "作為牛劍學術的導師總監，我謹代表牛劍學術歡迎所有學員，無論是現有的，還是即將成為我們一份子的您，歡迎您們來應用我們全新的 APP 及網站。",
    "p2": "牛劍學術為自己訂立的挑戰，就是確保提供給我們所有學員卓越的學術輔道。這是因為我們深切了解學員的期望與所需，所以我們必須一步到位，共同邁向成功之路。",
    "p3": "我的角色與責任是組建一個頂尖的導師團隊。我們的導師均是擁有超高學歷的學者（有些甚至是學術界内舉足輕重的人物），同時也是優秀且專業的教師。這是非常關鍵的，因為只精通於自己專科的學者並不等同出色的教育家。出色的教育家必須同時擁有同理心和良好的溝通技能。能將知識傳授給他人卻是教育的關鍵。",
    "p4": "我們確實對我們的導師團隊感到自豪。我們的導師都擁有牛劍 (牛津、劍橋大學) 的學術背景，而且都經過了嚴格的甄選：分兩個階段的簡歷審查程序，深入的面試，以及接受一套清晰而徹底的指引和內部規定。",
    "p5": "我們深信，我們導師團隊的才能是獨一無二的，而我們有足夠的信心，一旦您開始在牛劍學術優秀導師的指導下獲得出色的學術成就，我們必定得到您的認同及肯定。",
    "p6": "牛劍學術祝您在學習的道路上再創佳績！",
    "p7": " ",
    "p8": "羅伯特·芬奇",
    "p9": "導師總監",
    "step1": "導師先瞭解學生的學術水準、學術上的需要及目標並作出評估，再為學生定制個人化及目標性的學習方式及練習。每次上課都會跟進並就學習狀況與進度而調整，以正確及有效的教學模式，讓學生的學術成就得以提升及突破。",
    "step2": "我們所有的導師都是擁有英國牛津大學或劍橋大學（簡稱“Oxbridge”）學術資歷的教授、講師、博士後、研究生或畢業生。",
    "step3": "我們的導師除了擁有超卓的學術成就，對於教育、輔導新一代都充滿熱情與執著，在教育理念上有著很重的使命感。",
    "step4": "我們擁有不同的師資，可以讓你挑選不同科目專業的導師。除了IB及GCE A-LEVEL，導師還可以指導學生撰寫個人陳述，用於申請世界各地一流的大學，讓學生在眾多大學申請者中脫穎而出。",
    "step5": "使用簡單，可輕易於手機APP上隨時隨地預約課堂，學生可以使用桌上電腦、手提電腦、iPad平板電腦及手機輕鬆預約及線上上課。",
    "stepTitle": "為什麼選擇牛劍學術?",
    "stepTitle1": "正確有效的一對一線上輔導",
    "stepTitle2": "世界頂尖導師團隊",
    "stepTitle3": "教育使命",
    "stepTitle4": "各科目及個人陳述指導",
    "stepTitle5": "網頁及APP操作",
    "ourTutor": "我們的星級導師",
    "job1": "伊頓公學前任英文系主任",
    "job1_end":" ",
    "job2": "生物學",
    "job3": "牛津大學博士",
    "job4": "數學及哲學",
    "job5": "牛津大學前任講師",
    "job5_end":" ",
    "job6": "英語語言文學",
    "job7": "劍橋大學碩士",
    "job7_end":" ",
    "job8":"生物學",
    "job8_1":" ",
    "job8_2":"神經生理學副教授"
  },
  "en": {
    "regBtn":"Register Now",
    "teacher1":"After many years at Eton (eight of them as the Head of English) I have moved to Oxford, where I have worked one-to-one with students at all stages from 11 plus to Oxbridge Entrance and occasionally at undergraduate level, encouraging them to surpass what they believed they could achieve. I have always ...",
    "teacher2":"I am an Associate Professor in Neurophysiology at the University of Bristol and was previously Senior Lecturer in the department of Bioengineering at Imperial College London. I have run an independent research group since 2011 and combine fundamental research with university education at Undergraduate and Postgraduate levels. I obtained my first degree in Physiological Sciences from the University of Oxford, followed by a doctorate in Neuroscience from University College London.",
    "teacher3":"Hi, I am currently a consultant, having obtained a DPhil in Interdisciplinary Bioscience at the University of Oxford. Before my doctoral studies, I graduated at the top of my class in BSc Biology (1st class honours) at Imperial College London. I can provide tuition in GCSE/ A level/ AP/ IB Biology and guidance on university applications (resume, personal statements , interviews).",
    "teacher4":"I hold an undergraduate, Masters and DPhil (PhD) in Philosophy from the University of Oxford. I also hold a PGCE in Mathematics from Oxford University as well as a Fellowship in Learning and Teaching from the Higher Education Academy. I am very proud of being the first person in my family to be awarded a PhD and of ...",
    "teacher5":"Hello, I have a degree in English from Pembroke College, Cambridge University, and I have been tutoring students of all ages for over a decade. English Literature is my speciality and I most enjoy teaching students aged 16 and over, with whom I can share my passion for analysing text. There is so much to ...",
    "doctorJISOOJEAN":"DR JISOO JEAN",
    "doctorGeo":"DR GEOFFREY FERRARI",
    "doctorPAUL":"DR PAUL CHADDERTON",
    "doctor":"DOCTOR",
    "news": "News feed",
    "title1": "1 TO 1 ONLINE TUITION WITH WORLD-CLASS TUTORS FROM OXFORD AND CAMBRIDGE",
    "title1-1": "1 TO 1 ONLINE TUITION WITH ",
    "title1-2": "WORLD-CLASS ",
    "title1-3": "TUTORS FROM ",
    "title1-4": "OXFORD & CAMBRIDGE",
    "title1-5": " ",
    "desc1": "Tailor-made learning that suits your specific needs. ",
    "title2": "WHAT WE COVER ",
    "desc2": "Tutoring for all subjects within the A-level and IB curricula; University Applications, including advice on Admissions and Personal Statements; Interview Practice and essential skills including exam technique.",
    "title3": "OUR TUTORS",
    "desc3": "All our Tutors have academic backgrounds from the Universities of Oxford and Cambridge. You can learn from Professors, Lecturers, Postdoctorates, Postgraduates and Graduates - all from Oxford and Cambridge. ",
    "title4": "HOW WE DO IT",
    "desc4": "Assessment and interview before lessons to understand the problems, needs and goals of each individual student.",
    "desc5": "The Tutor then devises a specific tailor-made programme to help the student achieve his/her goals and objectives. ",
    "title5": "MESSAGE FROM OUR TUTOR DIRECTOR",
    "p1": "As Newton Tutor Director, I welcome all Newton clients, both current and prospective to our brand new app and website. ",
    "p2": "We at Newton have set ourselves the challenge of guaranteeing academic excellence to all our clients. And that is because we know that is what clients expect, that settling for half measures is no path to success. ",
    "p3": "With that in mind, my role has been to assemble a team of tutors, who are all high-flying academics in their own right, but also expert teachers. For it is one thing to know one's subject inside out; but it is quite another to possess the empathy and communication skills to be able to impart that knowledge to others. ",
    "p4": "Indeed, we are proud that our team of exclusively Oxbridge tutors has undergone careful and rigorous selection: a two-stage CV-vetting process, an intensive interview, and provision of a clear and thorough set of guidance and house rules. ",
    "p5": "We believe that the calibre of our tutors is unique, and we have full confidence that you will agree with us once you begin achieving outstanding success along your chosen academic path in the hands of our Newton tutors.",
    "p6": " We at Newton wish you all the best with your studies! ",
    "p7": "Yours sincerely,",
    "p8": "Robert Finch",
    "p9": "Tutor Director",
    "step1": "The Tutor makes an initial informed assessment of the student's academic standard, needs and goals, and then formulates individualised, targeted learning strategies and exercises for the student. Each lesson will be reviewed and adjustments made according to the learning situation and relevant progress, enabling students to attain the academic achievements and breakthroughs to which they aspire, using the right and effective teaching methods.",
    "step2": "Our Tutor team consists of professors, lecturers, postdocs, postgraduates and graduates, all with academic qualifications and backgrounds from the two world-famous Universities of Oxford and Cambridge (Oxbridge).",
    "step3": "In addition to their outstanding academic achievements and credentials, our Tutors are full of enthusiasm in cultivating the new generation, displaying total commitment and an admirable sense of mission and devotion to high class education.",
    "step4": "We have three levels of Tutors from which you can choose - albeit they are all experts in their various different subjects. In addition to teaching subjects in both IB and GCE A-Level courses, Tutors are also well-equipped to give expert guidance and advice to students in writing their Personal Statements for applications to prestigious universities across the world, helping them to stand out from any group of university applicants.",
    "step5": "We have developed an easy-to-use platform, providing real convenience in booking lessons anytime, anywhere, simply by registering with our mobile app. Students can choose to use their desktop/laptop computers, iPads or mobile phones for easy booking and online attendance of lessons.",
    "stepTitle": "WHY CHOOSE NEWTON?",
    "stepTitle1": "Right and Effective: One-to-One Online Tuition",
    "stepTitle2": "World-Class Tutor Team",
    "stepTitle3": "Educational Mission",
    "stepTitle4": "Expert Guidance in every Subject and University Applications Personal Statement",
    "stepTitle5": "Easy-to-use Technology - Mobile App and Website",
    "ourTutor": "OUR STAR TUTORS",
    "job1": "FORMER HEAD OF ENGLISH",
    "job1_end":"AT ETON COLLEGE",
    "job2": "BIOLOGY",
    "job3": "OXFORD UNIVERSITY PhD",
    "job4": "MATHS & PHILOSOPHY",
    "job5": "FORMER LECTURER",
    "job5_end":"OXFORD UNIVERSITY",
    "job6": "ENGLISH LANGUAGE ",
    "job7": "& LITERATURE",
    "job7_end":"CAMBRIDGE UNIVERSITY MA",
    "job8":"BIOLOGY",
    "job8_1":"ASSOCIATE PROFESSOR",
    "job8_2":"IN NEUROPHYSIOLOGY"
  }
}
</i18n>
